// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3759d554","988":"d316b554"}[chunkId] + ".chunk.js";
};